import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {ModuleService} from '../../../services/module.service';
import {Store, select, Action} from '@ngrx/store';
import * as fromStore from '../../../store';
import {Observable, of} from 'rxjs';
import * as featureActions from '../../index';
import {catchError, map, switchMap, withLatestFrom} from 'rxjs/operators';
import * as actions from '../../../store/actions';
import {UpdateInfoModel} from '../../updateInfo/update-info.model';
import {moduleValueType, updateInfoType} from '../../../shareModel';

@Injectable()
export class ModuleEffects {
  private actions$ = inject(Actions);
  private store$ = inject(Store<fromStore.State>);
  private moduleService = inject(ModuleService);

  constructor() {}

  readAllModule$ = createEffect(() => this.actions$.pipe(
  ofType(featureActions.ModuleActionTypes.GetModules),
  withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
  switchMap(([action, user]) => {
    return this.moduleService.ReadAllModule(user.otp).pipe(
      map((res: any) => {
        if (res.result) {
          return new featureActions.LoadModules({modules: res.msg.body});
        }
      })
    );
  })
));
  readModuleByRegion$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.ModuleActionTypes.GetModulesByRegion),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([payload, user]) => {
      const params = {
        otp: user.otp,
        RegionId: user.RegionId
      };
      return this.moduleService.ReadModuleByRegion(params).pipe(
        map((res: any) => {
          if (res.result) {
            return new featureActions.LoadModules({modules: res.msg.body});
          }
        })
      );
    })
  ));
  updateModule$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.ModuleActionTypes.UpdateModules),
    map((action: featureActions.UpdateModules) => action.payload),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([payload, user]) => {
      const data = payload.modules.map(item => {
        return {Id: item['Id'], Value: Number(item['Value']).toString()};
      });
      const params = {
        otp: user.otp,
        data: data,
        RegionId: payload.from.RegionId,
        Package: payload.from.Package
      };
      return this.moduleService.UpdateModule(params).pipe(
        map((res: UpdateInfoModel) => {
          const updateRes: UpdateInfoModel = { ...res, type: updateInfoType.EditModule };
          if (res.result) {
            return new featureActions.UpdateInfoSuccessAction(updateRes);
          } else {
            return new featureActions.UpdateInfoFailAction(updateRes);
          }
        }),
        catchError(error => {
          const res: UpdateInfoModel = {
            result: false,
            errmsg: error,
            type: updateInfoType.EditModule
          };
          return of(new featureActions.UpdateInfoFailAction(res));
        })
      );
    })
  ));

}
